/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { ContentPaginationResponseDto } from '../model/contentPaginationResponseDto';
import { ContentRequestDto } from '../model/contentRequestDto';
import { ContentResponseDto } from '../model/contentResponseDto';
import { ValidationError } from '../model/validationError';

export enum contentsGetTypeEnum {
  term_and_condition = 'term_and_condition',
  privacy = 'privacy',
  about_us = 'about_us',
  contact_us = 'contact_us',
  pdpa = 'pdpa',
  cookie_policy = 'cookie_policy',
}
export enum contentsGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum contentsIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class ContentsService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public contentsGet$(page?: number, limit?: number, type?: string, title?: string, language?: string, isActive?: boolean, sort?: string): Observable<ContentPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/contents`, { page, limit, type, title, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public contentsIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/contents/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public contentsIdGet$(id: string, language?: string): Observable<ContentResponseDto> {
    return this.api.get(`${apiBaseUrl()}/contents/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public contentsIdPut$(id: string, body: ContentRequestDto): Observable<ContentResponseDto> {
    return this.api.put(`${apiBaseUrl()}/contents/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public contentsIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/contents/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public contentsPost$(body: ContentRequestDto): Observable<ContentResponseDto> {
    return this.api.post(`${apiBaseUrl()}/contents`, body, undefined);
  }
}
